import React from 'react';

import I18n from '../../../lib/i18n';
import { IUnpackedRelatedChannel } from '../../../models/MessagePreview/UnpackedRelatedChannel';
import OunceRelatedChannel from './OunceRelatedChannel';

interface IProps {
  relatedChannels: IUnpackedRelatedChannel[];
}

const OunceRelatedChannelList = (props: IProps) => {
  const { relatedChannels } = props;

  if (relatedChannels && relatedChannels.length !== 0) {
    const relatedChannelNodes = relatedChannels.map((relatedChannel, index) => (
      <OunceRelatedChannel relatedChannel={relatedChannel} key={index} />
    ));

    return (
      <div className="related-channels">
        <div className="related-channels-title">
          <span className="related-channels-title-text">{I18n.t('activerecord.attributes.message.related_topics')}</span>
        </div>
        <div>
          {relatedChannelNodes}
        </div>
      </div>
    );
  }

  return null;
};

export default OunceRelatedChannelList;
